/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { RequestItemStatus } from './RequestItemStatus';
import {
    RequestItemStatusFromJSON,
    RequestItemStatusFromJSONTyped,
    RequestItemStatusToJSON,
    RequestItemStatusToJSONTyped,
} from './RequestItemStatus';
import type { StaffUserRef } from './StaffUserRef';
import {
    StaffUserRefFromJSON,
    StaffUserRefFromJSONTyped,
    StaffUserRefToJSON,
    StaffUserRefToJSONTyped,
} from './StaffUserRef';
import type { StaffItemDisplayStatus } from './StaffItemDisplayStatus';
import {
    StaffItemDisplayStatusFromJSON,
    StaffItemDisplayStatusFromJSONTyped,
    StaffItemDisplayStatusToJSON,
    StaffItemDisplayStatusToJSONTyped,
} from './StaffItemDisplayStatus';
import type { RequestItemVisibility } from './RequestItemVisibility';
import {
    RequestItemVisibilityFromJSON,
    RequestItemVisibilityFromJSONTyped,
    RequestItemVisibilityToJSON,
    RequestItemVisibilityToJSONTyped,
} from './RequestItemVisibility';
import type { StaffItemResponse } from './StaffItemResponse';
import {
    StaffItemResponseFromJSON,
    StaffItemResponseFromJSONTyped,
    StaffItemResponseToJSON,
    StaffItemResponseToJSONTyped,
} from './StaffItemResponse';

/**
 * 
 * @export
 * @interface StaffRequestItem
 */
export interface StaffRequestItem {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    request_id: string;
    /**
     * 
     */
    label: string;
    /**
     * 
     */
    instructions: string | null;
    /**
     * 
     */
    participant_reason: string | null;
    /**
     * 
     */
    item_group: string | null;
    /**
     * 
     */
    visibility: RequestItemVisibility;
    /**
     * 
     */
    due_at: Date | null;
    /**
     * 
     */
    assigned_user: StaffUserRef | null;
    /**
     * 
     */
    sort_order: number;
    /**
     * 
     */
    status: RequestItemStatus;
    /**
     * 
     */
    display_status: StaffItemDisplayStatus;
    /**
     * Line under the chip, e.g. "Uploaded Oct 19" or the participant's note
     */
    status_caption: string | null;
    /**
     * 
     */
    revision: number;
    /**
     * 
     */
    document_count: number;
    /**
     * 
     */
    responses: Array<StaffItemResponse>;
}



/**
 * Check if a given object implements the StaffRequestItem interface.
 */
export function instanceOfStaffRequestItem(value: object): value is StaffRequestItem {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('request_id' in value) || value['request_id'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('instructions' in value) || value['instructions'] === undefined) return false;
    if (!('participant_reason' in value) || value['participant_reason'] === undefined) return false;
    if (!('item_group' in value) || value['item_group'] === undefined) return false;
    if (!('visibility' in value) || value['visibility'] === undefined) return false;
    if (!('due_at' in value) || value['due_at'] === undefined) return false;
    if (!('assigned_user' in value) || value['assigned_user'] === undefined) return false;
    if (!('sort_order' in value) || value['sort_order'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('display_status' in value) || value['display_status'] === undefined) return false;
    if (!('status_caption' in value) || value['status_caption'] === undefined) return false;
    if (!('revision' in value) || value['revision'] === undefined) return false;
    if (!('document_count' in value) || value['document_count'] === undefined) return false;
    if (!('responses' in value) || value['responses'] === undefined) return false;
    return true;
}

export function StaffRequestItemFromJSON(json: any): StaffRequestItem {
    return StaffRequestItemFromJSONTyped(json, false);
}

export function StaffRequestItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): StaffRequestItem {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'request_id': json['request_id'],
        'label': json['label'],
        'instructions': json['instructions'],
        'participant_reason': json['participant_reason'],
        'item_group': json['item_group'],
        'visibility': RequestItemVisibilityFromJSON(json['visibility']),
        'due_at': (json['due_at'] == null ? null : parseDateTime(json['due_at'])),
        'assigned_user': StaffUserRefFromJSON(json['assigned_user']),
        'sort_order': json['sort_order'],
        'status': RequestItemStatusFromJSON(json['status']),
        'display_status': StaffItemDisplayStatusFromJSON(json['display_status']),
        'status_caption': json['status_caption'],
        'revision': json['revision'],
        'document_count': json['document_count'],
        'responses': ((json['responses'] as Array<any>).map(StaffItemResponseFromJSON)),
    };
}

export function StaffRequestItemToJSON(json: any): StaffRequestItem {
    return StaffRequestItemToJSONTyped(json, false);
}

export function StaffRequestItemToJSONTyped(value?: StaffRequestItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'request_id': value['request_id'],
        'label': value['label'],
        'instructions': value['instructions'],
        'participant_reason': value['participant_reason'],
        'item_group': value['item_group'],
        'visibility': RequestItemVisibilityToJSON(value['visibility']),
        'due_at': value['due_at'] == null ? value['due_at'] : serializeDateTime(value['due_at']),
        'assigned_user': StaffUserRefToJSON(value['assigned_user']),
        'sort_order': value['sort_order'],
        'status': RequestItemStatusToJSON(value['status']),
        'display_status': StaffItemDisplayStatusToJSON(value['display_status']),
        'status_caption': value['status_caption'],
        'revision': value['revision'],
        'document_count': value['document_count'],
        'responses': ((value['responses'] as Array<any>).map(StaffItemResponseToJSON)),
    };
}

